'use client'
import { useMemoizedContentGetter } from 'utils/contentful'
import { Typography, MediaImageStandard, LinkButton } from 'components/Contentful'
import Section from 'components/Section'
import styles from './MemberStoriesCloserStatement.module.scss'
import { Grid } from '@achieve/ascend'
import { useViewportSmallerThan } from 'utils/viewport'
import { BREAKPOINTS } from 'constants/viewport'

function MemberStoriesCloserStatement({ content }) {
  const sectionVariationObject = {
    ...content?.fields?.experiment,
    variant: content?.fields?.experimentVariation,
  }
  const isMobile = useViewportSmallerThan(BREAKPOINTS.xl)

  const { title, image, button, altCta } = useMemoizedContentGetter(content, [
    'title',
    'image',
    'button',
    'altCta',
  ])

  return (
    <Section className={styles['closer-statement-section']} data-testid="closer-statement-section">
      <Grid
        container
        direction={isMobile ? 'column' : 'row'}
        alignItems="center"
        className={styles['outer-grid-container']}
        data-testid="closer-statement-outer-grid-container"
      >
        <Grid
          size={{ xs: 8, xl: 6.5 }}
          className={styles['grid-item-text']}
          data-testid="closer-statement-grid-item-text"
        >
          <div className={styles['text-container']} data-testid="closer-statement-text-container">
            <Typography
              content={title?.textContent}
              variant="displayLg"
              fontWeight="bold"
              className={styles['title']}
            />
            <div className={styles['cta-container']}>
              {button && (
                <LinkButton
                  className={styles['button']}
                  content={button}
                  typographicOptions={{
                    className: 'bodySm lg:bodyLg font-bold!',
                    'data-testid': 'closer-statement-button-text',
                  }}
                  color="primary"
                  data-testid="closer-statment-button"
                  track={{
                    ...{
                      list_name: 'Member Stories Closer Statement',
                      click_id: 'Get Started',
                      click_position: '0',
                      nav_link_section: 'Closer Statement',
                      track_event: 'internal_campaign_click',
                      event_action: 'link_click',
                      event_type: 'link_click',
                    },
                    ...button.event,
                    sectionVariationObject,
                  }}
                />
              )}
              {Object.hasOwnProperty.call(altCta, 'textContent') && (
                <Typography
                  content={altCta.linkText}
                  variant="bodySm"
                  fontWeight="bold"
                  className={styles['alt-cta']}
                  data-testid="closer-statement-text-area-alt-cta"
                />
              )}
            </div>
          </div>
        </Grid>
        <Grid
          size={{ xs: 4, xl: 5.5 }}
          className={styles['grid-item-image']}
          data-testid="closer-statement-grid-item-image"
        >
          <div className={styles['img-container']}>
            <span>
              <MediaImageStandard
                objectFit="contain"
                objectPosition="center bottom"
                height={isMobile ? 250 : 350}
                content={image?.mediaContent}
                alt={image?.mediaAltText}
                data-testid="closer-statement-image"
                placeholder={'empty'}
              />
            </span>
          </div>
        </Grid>
      </Grid>
    </Section>
  )
}
export { MemberStoriesCloserStatement }
export default MemberStoriesCloserStatement
